export class ProdottiUpgradeItem {
	constructor() {
		this.itemID = null;
		this.pacchettoID = null;
		this.pacchettoUpgradeID = null;
		this.pacchettoUpgrade = null;
		this.regole = null;
		this.tipo = null;
		this.immagine = null;
		this.immagine_file = null;
	}
	itemID: number;
	pacchettoID: number | null;
	pacchettoUpgradeID: number | null;
	pacchettoUpgrade: string;
	regole: string;
	immagine: string;
	immagine_file: string;
	tipo: number | null;
}